import { slugifyFormName } from '@features/forms/components/wizard-steps/preview-step/helpers/previewPublish';

import { AddToMode, DiscountType, FormTemplate } from '../types';
import { FormTemplateApiItem } from '../types/formTemplatesApi';
import { mapFormApiFields } from './mapFormApiFields';

const mapAddToMode = (mode: string | null): AddToMode => {
  if (!mode) {
    return 'group';
  }
  const normalized = mode.toLowerCase().replace(/-/g, '_');
  return normalized === 'member_list' ? 'member_list' : 'group';
};

const mapDiscountType = (type: string | null | undefined): DiscountType =>
  type?.toLowerCase() === 'flat' ? 'flat' : 'percentage';

export const mapFormTemplateApiItem = (
  item: FormTemplateApiItem,
  index: number
): FormTemplate => {
  const discountEnabled = item.discount_config?.is_enabled ?? false;
  const templateId = slugifyFormName(item.name) || `template-${index}`;

  return {
    id: templateId,
    name: item.name,
    summary: item.summary ?? '',
    description: item.description ?? '',
    iconUrl: item.icon_url ?? undefined,
    addToMode: mapAddToMode(item.add_to_mode),
    feeAmount: item.fee_amount ?? undefined,
    acceptInstallments: item.is_partial_payment_enabled ?? undefined,
    minPartialPaymentAmount: item.min_partial_payment_amount ?? undefined,
    applyDiscount: discountEnabled,
    discountType: discountEnabled
      ? mapDiscountType(item.discount_config?.type)
      : undefined,
    discountValue: discountEnabled ? item.discount_config?.value : undefined,
    defaultFields: mapFormApiFields(
      item.fields ?? [],
      `template-${templateId}`,
      { alwaysGenerateIds: true }
    )
  };
};

export const mapFormTemplatesApi = (
  items: FormTemplateApiItem[]
): FormTemplate[] => items.map(mapFormTemplateApiItem);
